import { render } from "./BaseButton.vue?vue&type=template&id=6ee246f7"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=6ee246f7&lang=scss"

import exportComponent from "/Users/garay/code/omnichannel/dashboard-agente/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__